import Render from '@Views/root/user/offices.html'
import { Vue, Component } from 'vue-property-decorator'
import { IOffice, IUser, IBreadcrumbItem, IPopin, IPopinAction } from '@Store/types'
import { Office, Common } from '@Models/index'
import { Dictionary } from 'vue-router/types/router'
import { breadcrumb, notif, office, popIn, user } from '@Store/modules'
import { IDropdownItem } from '@Components/input/dropdown'
import { RfeHelper } from '@Helpers/rfe'

@Render
@Component({})
export class Offices extends Vue {

	private deploy: Dictionary<boolean> = {}
	private selectedOfiId: string = ''

	// @State('user') stateUser: UserState
	// @Getter('office/offices') allOffices: () => IOffice[]
	// @Getter('office/isActive') isActive: (office: IOffice, usr_id?: string) => boolean
	// @Getter('user/currentUser') currentUser: IUser
	// @Mutation('breadcrumb/updateItems') updateItems: (items: IBreadcrumbItem[]) => void
	// @Action('office/addOffice') addNewOffice: (office: IOffice) => void
	// @Action('office/deleteOffice') deleteOffice:(ofiId: string) => Promise<any>
	// @Action('office/activateOffice') activateOffice:(ofiId: string) => Promise<any>

	mounted() {
		this.$emit('navigate', 'offices')
		this.initializeBreadcrumb()
		this.selectedOfiId = RfeHelper.defaultOfficeId()
	}

	get offices() : IOffice[] {
		return office.offices.filter(o => { return office.isActive(o) })
	}
	get disableOffices() : IOffice[] {
		return office.offices.filter(o => { return !office.isActive(o) })
	}

	// le bloc " Facturation électronique " n'est proposé qu'au titulaire éligible (mêmes règles que le popin RFE)
	get canManageRfeDefaultOffice(): boolean {
		return RfeHelper.canManageDefaultOffice()
	}

	// la liste des cabinets actifs proposés dans le sélecteur du cabinet par défaut RFE
	get rfeOfficeItems(): IDropdownItem[] {
		return RfeHelper.activeOffices().map(o => ({
			value: o.id,
			label: o.coordinates && o.coordinates.name || ''
		}))
	}

	// le cabinet actuellement retenu pour la réception des factures RFE
	get rfeDefaultOfficeId(): string {
		return RfeHelper.defaultOfficeId()
	}

	// valeur liée au sélecteur (choix local en attente de confirmation)
	get rfeSelectedOfficeId(): string {
		return this.selectedOfiId
	}

	// vrai si ce cabinet est celui désigné pour la réception des factures RFE
	isRfeDefaultOffice(office: IOffice): boolean {
		return this.canManageRfeDefaultOffice && !!office && office.id === this.rfeDefaultOfficeId
	}

	// au changement du sélecteur on demande confirmation
	onSelectRfeOffice(ofiId: string): void {

		if (!ofiId || ofiId === this.rfeDefaultOfficeId) {
			this.selectedOfiId = this.rfeDefaultOfficeId
			return
		}

		this.selectedOfiId = ofiId

		let target: IOffice = RfeHelper.activeOffices().find(o => o.id === ofiId)
		let name: string = target && target.coordinates && target.coordinates.name || ''

		let action: IPopinAction = {
			label: this.$t('vm.root.user.offices.rfe.confirm.action').toString(),
			title: this.$t('vm.root.user.offices.rfe.confirm.action').toString(),
			callback: async (data: any, updateLoading: (loading: boolean) => void) => {
				try {
					updateLoading(true)
					await user.updateRfeDefaultOffice({ ofiId })
					await Promise.all([user.reloadUser(), office.loadOffices()])
					this.selectedOfiId = RfeHelper.defaultOfficeId()
					notif.success({ message: this.$t('vm.root.user.offices.rfe.success').toString(), actions: [], delay: 5000, canClose: true })
				} catch (err) {
					this.selectedOfiId = RfeHelper.defaultOfficeId()
					notif.error({ message: this.$t('vm.root.user.offices.rfe.failed').toString(), actions: [], delay: 5000, canClose: true })
					updateLoading(false)
					return Promise.reject(err)
				}
				updateLoading(false)
			},
			stayOpen: false
		}

		let popin: IPopin = {
			title: this.$t('vm.root.user.offices.rfe.confirm.title').toString(),
			content: this.$t('vm.root.user.offices.rfe.confirm.content', { name }).toString(),
			action,
			cancelAction: () => { this.selectedOfiId = this.rfeDefaultOfficeId },
			cancelLabel: this.$t('vm.root.user.offices.rfe.confirm.cancel').toString()
		}

		popIn.info(popin)
	}

	isOwner(office: IOffice): boolean {
		return !!office && office.creator_usr_id === user.currentUser.id
	}

	owner(office: IOffice): IUser {
		return office.links.find(u => { return u.id === office.creator_usr_id })
	}

	toggle(id: string, createId?: string): any {
		let selectedId: string = !!createId ? createId : id
		this.deploy[selectedId] = !this.deploy[selectedId]
		this.$forceUpdate()
	}

	isToggle(id: string, createId?: string): boolean {
		let selectedId: string = !!createId ? createId : id
		return this.deploy[selectedId]
	}

	addOffice(): void {
		let createId: string = Common.generateId()
		let _office: IOffice = Office.createNewOffice(createId, user.user.id)
		_office.links.push(user.currentUser)
		office.addOffice(_office)

		this.$router.push({name:'office-coordinates', params:{ofi_id: createId}})
	}

	submitDeleteOffice(_office: IOffice): void {
		office.deleteOffice(_office.id)
	}

	submitActivateOffice(_office: IOffice): void {
		office.activateOffice(_office.id)
	}

	private initializeBreadcrumb(): void {
		let item1: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.user').toString(), link:'user-account' }
		let item2: IBreadcrumbItem = { label: this.$i18n.tc('vm.root.breadcrumb.offices', this.offices.length).toString() }
		breadcrumb.updateItems([item1, item2])
	}
}
